export default __webpack_public_path__ + "static/media/h5.eb84001a.png";